import React, { useContext } from "react";
import ActionableCardList, { ActionableCardListItem } from "../../components/ActionableCardList";
import { ChasablesContext } from "../../context/ChasablesContext";
import { PageContext } from "../../context/PageContext";
import Grid from "@mui/material/Grid2";
import { Skeleton, Stack } from "@mui/material";
import AttachEmailIcon from "@mui/icons-material/AttachEmail";
import SearchIcon from "@mui/icons-material/Search";
import { ActionTypeEnum } from "../../models/ChasableModels";

const Chasables = () => {
  const { setNewTitle } = useContext(PageContext);
  const { chasables, isLoading } = useContext(ChasablesContext);

  React.useEffect(() => {
    setNewTitle("Receivables");
  }, [setNewTitle]);

  const chasableActions =
    chasables?.actions.filter(
      ({ type }) =>
        type === ActionTypeEnum.Chasable ||
        type === ActionTypeEnum.NewInvoice ||
        type === ActionTypeEnum.PromiseToPayBroken
    ) ?? [];

  const items: ActionableCardListItem[] = [
    isLoading
      ? { title: "Suggested", icon: AttachEmailIcon, link: "", loading: true }
      : {
          title: "Suggested",
          icon: AttachEmailIcon,
          link: chasableActions.length > 0 ? `/chasables/suggested/${chasableActions[0].id}` : "/chasables/suggested",
          telemetryReceivablesHubAction: "suggested" as const,
        },
    {
      title: "Search",
      icon: SearchIcon,
      link: "/chasables/search",
      telemetryReceivablesHubAction: "search" as const,
    },
  ];

  return (
    <Stack justifyContent="space-between" height="100%">
      <ActionableCardList items={items} />
      <Grid container={true}>
        <Grid size={12} textAlign="center" mb={1}>
          {chasables ? (
            <>
              Last update:{" "}
              {Intl.DateTimeFormat(Office.context.displayLanguage, {
                dateStyle: "short",
                timeStyle: "short",
              }).format(new Date(chasables.lastUpdated))}
            </>
          ) : (
            <Skeleton />
          )}
        </Grid>
      </Grid>
    </Stack>
  );
};

export default Chasables;
